/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Voice_DescriptionInputs */

const en_homepage_features_voice_description = /** @type {(inputs: Homepage_Features_Voice_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A.I. voices used to sound robotic - today, they sound just like a real person! Give it a try by clicking above.`)
};

const es_homepage_features_voice_description = /** @type {(inputs: Homepage_Features_Voice_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las voces de I.A. solían sonar robóticas - hoy, suenan como una persona real. ¡Pruébalo haciendo clic arriba!`)
};

/**
* | output |
* | --- |
* | "A.I. voices used to sound robotic - today, they sound just like a real person! Give it a try by clicking above." |
*
* @param {Homepage_Features_Voice_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_voice_description = /** @type {((inputs?: Homepage_Features_Voice_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Voice_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_voice_description(inputs)
	return en_homepage_features_voice_description(inputs)
});